import React from "react";
import Contact from "../components/Contact";

export default function AboutUs() {
  return (
    <section className="about-us py-5">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* About Us Text Section */}
          <div className="col-lg-6">
            <h2 className="display-4 fw-bold text-body-emphasis">
              About Dessert Haven
            </h2>
            <p className="lead">
              At Dessert Haven, we believe every moment is worth celebrating.
              That’s why we craft delightful, high-quality desserts to bring joy
              to your special occasions or even your everyday indulgences.
            </p>
            <p>
              From customizable treat boxes to gourmet, gluten-free options, we
              cater to diverse tastes and dietary needs. Our commitment to using
              the finest ingredients ensures every bite is as memorable as the
              moments you share with your loved ones.
            </p>
            <p>
              Whether you need same-day delivery or are planning a big event,
              Dessert Haven is here to make your sweetest dreams come true.
            </p>
          </div>

          {/* About Us Image Section */}
          <div className="col-lg-6">
            <img
              src="https://images.pexels.com/photos/3026803/pexels-photo-3026803.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
              alt="Dessert Haven"
              className="img-fluid rounded shadow"
            />
          </div>
        </div>
      </div>
      {/* Contact Us Section */}
      <Contact />
    </section>
  );
}
